import React, { useState } from 'react';
import { Grid, IconButton, MenuItem, Select, TextField } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const NewRow = ({
  firstValueDefault = '',
  goSave,
  twoValue = false,
  setNewRow,
  options,
  selectable = false,
  // valueOptions = [
  //   [{ type: 'TextField', title: 'Название', onChange: () => {} }],
  // ],
}) => {
  const [firstValue, setFirstValue] = useState(firstValueDefault);
  const [secondValue, setSecondValue] = useState('');
  // const [dynamicValue, setDynamicValue] = useState([]);

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={twoValue ? 6 : 9}>
        {selectable ? (
          <Select
            size='small'
            fullWidth
            id='demo-simple-select'
            value={secondValue}
            onChange={(e) => setSecondValue(e.target.value)}
          >
            {options.map((item, index) => (
              <MenuItem key={index} value={item._id || item.id || item.value}>
                {item?.title || item?.name || item}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <TextField
            sx={{ pt: 1 }}
            size='small'
            fullWidth
            id='outlined-required'
            value={firstValue}
            onChange={(e) => setFirstValue(e.target.value)}
          />
        )}
      </Grid>
      {twoValue && (
        <Grid item xs={3}>
          <TextField
            sx={{ pt: 1 }}
            size='small'
            fullWidth
            id='outlined-required'
            value={secondValue}
            onChange={(e) => setSecondValue(e.target.value)}
          />
        </Grid>
      )}
      <Grid item xs={1}>
        <IconButton
          sx={{ pl: 0 }}
          aria-label='delete'
          onClick={() => goSave(firstValue, secondValue)}
        >
          <SaveIcon />
        </IconButton>
      </Grid>
      <Grid item xs={2}>
        <IconButton aria-label='delete' onClick={() => setNewRow(false)}>
          <HighlightOffIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default NewRow;
